import NeedOffersByCategory from './NeedOffersByCategory.jsx';

export default NeedOffersByCategory;


// WEBPACK FOOTER //
// ./components/partials/need-offer-by-category/index.js